/* What's in it — the ingredient carousel on a blend's product page (sections/product-which.liquid).
 *
 * THE HTML IS A LIST; THIS TURNS IT INTO A CAROUSEL. Every ingredient is already in the page with
 * its drawing, its name, its description and its door, in order. This adds `is-js` to the box,
 * un-hides the arrows and the thumbs, and moves one index around: the active <li> gets `is-active`,
 * its neighbours `is-prev` / `is-next` (the faded pictures either side), and the stylesheet does the
 * rest. Nothing here is load-bearing for a crawler or for JavaScript-off — the list is the content.
 *
 * Arrows, the thumbs, the keyboard (left/right while the box has focus) and a plain swipe on a
 * touch screen all call the same go(). The end wraps: after the last ingredient comes the first,
 * because a blend is a ring, not a line, and a dead arrow at either end is a small failure.
 */
(() => {
  document.querySelectorAll('.pp-ingc').forEach((box) => {
    const items = [...box.querySelectorAll(':scope > .pp-ingc__slides > .pp-ing')];
    const n = items.length;
    if (!n) return;
    box.classList.add('is-js');
    if (n < 2) return;

    const thumbs = [...box.querySelectorAll('[data-ingc="go"]')];
    box.querySelectorAll('[data-ingc], .pp-ingc__thumbs').forEach((el) => { el.hidden = false; });

    let i = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));

    function go(to) {
      i = ((to % n) + n) % n;
      const prev = (i - 1 + n) % n;
      const next = (i + 1) % n;
      items.forEach((el, k) => {
        el.classList.toggle('is-active', k === i);
        /* Two ingredients: the other one is both prev and next; it shows once, on the right. */
        el.classList.toggle('is-prev', k === prev && n > 2);
        el.classList.toggle('is-next', k === next && k !== i);
      });
      thumbs.forEach((b) => b.setAttribute('aria-current', String(Number(b.dataset.i) === i)));
    }

    box.addEventListener('click', (e) => {
      const b = e.target.closest('[data-ingc]');
      if (!b || !box.contains(b)) return;
      if (b.dataset.ingc === 'prev') go(i - 1);
      else if (b.dataset.ingc === 'next') go(i + 1);
      else if (b.dataset.ingc === 'go') go(Number(b.dataset.i) || 0);
    });

    /* A faded neighbour is a promise of what is next; clicking it should go there, not to its page. */
    box.addEventListener('click', (e) => {
      const pic = e.target.closest('.pp-ing__pic');
      if (!pic) return;
      const li = pic.closest('.pp-ing');
      if (li && !li.classList.contains('is-active')) {
        e.preventDefault();
        go(items.indexOf(li));
      }
    });

    box.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
    });

    /* Swipe: a horizontal pointer travel of 40px or more across the pictures. */
    const stage = box.querySelector('.pp-ingc__slides');
    let x0 = null;
    stage.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') x0 = e.clientX; });
    stage.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) >= 40) go(dx < 0 ? i + 1 : i - 1);
    });
    stage.addEventListener('pointercancel', () => { x0 = null; });

    go(i);
  });
})();
